export const EXPLORER = process.env.EXPLORER || 'https://etherscan.io';
export const SENTRY_ORG = process.env.SENTRY_ORG || 'test-hrn';
export const SENTRY_PROJECT = process.env.SENTRY_PROJECT || 'javascript-nextjs';
